import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate, Outlet, useSearchParams, useParams, useLocation } from "react-router-dom";
import { Users } from "./modules/containers/Admin";
import SimplifiedDashboard from "./modules/containers/Admin/SimplifiedDashboard";
import AdminUserProfile from "./modules/containers/Admin/AdminUserProfile";
import Creations from "./modules/containers/Admin/Creations";
import AdminCreationDetail from "./modules/containers/Admin/AdminCreationDetail";
import NewsDashboard from "./modules/containers/Admin/NewsDashboard";
import AdminNewsDetail from "./modules/containers/Admin/AdminNewsDetail";
import "./modules/scss/shared.scss";
// import { useKeyboardDetection } from "./helpers/hooks";
// Import debug tools for performance testing (only in development)
if (import.meta.env.NODE_ENV === 'development') {
  import('./helpers/debugPerformance');
}
import LayoutAdmin from "./modules/containers/Admin/LayoutAdmin";

import DashboardsLayout from "./modules/containers/Admin/DashboardsLayout";
import Engagement from "./modules/containers/Admin/Engagement";
import Creators from "./modules/containers/Admin/Creators";
import Overview from "./modules/containers/Admin/Overview";
import InviteUsers from "./modules/containers/Admin/InviteUsers";
import Content from "./modules/containers/Admin/Content";
import Revenue from "./modules/containers/Admin/Revenue";
import Login from "./modules/containers/Auth/Login";
import Register from "./modules/containers/Auth/Register";
import GoogleAuthCallback from "./modules/containers/Auth/GoogleAuthCallback";
import { supabase } from "./supabase";
import Paiements from "./modules/containers/Admin/Paiements";
import SendInvite from "./modules/containers/Auth/SendInvite";
import { SessionBootstrapSkeleton } from "./modules/components/Skeletons/BatchScreenSkeletons";
import NotFound from "./modules/containers/NotFound/NotFound";
import { Profile } from "./modules/containers/Profile";
import CreatorProfile from "./modules/containers/CreatorProfile/CreatorProfile";
import { useDispatch, useSelector } from "react-redux";
import { setSessionUser } from "./modules/Reducers/actions/authActions";
import useSessionProfile from "./hooks/useSessionProfile";
import SendRecover from "./modules/containers/Auth/SendRecover";
import RecoverPwd from "./modules/containers/Auth/RecoverPwd";
import CompleteProfile from "./modules/containers/Auth/CompleteProfile";
import ErrorPage from "./modules/containers/Error/ErrorPage";
import EditProfileSetting from "./modules/containers/Profile/EditProfile/EditProfileSetting";
import Layout from "./modules/components/Layout/Layout";
// import HomePage from "./modules/containers/HomePage/HomePage";
import InviteCommunity from "./modules/containers/Profile/InviteCommunity/InviteCommunity";
import InviteContacts from "./modules/containers/Profile/InviteContacts/InviteContacts";
import ChangePwd from "./modules/containers/Profile/ChangePwd/ChangePwd";
import MyCreations from "./modules/containers/MyCreations/MyCreations";
import News from "./modules/containers/News/News";
import WriteNews from "./modules/containers/News/WriteNews";
import EditNews from "./modules/containers/News/EditNews";
import AddCreation from "./modules/containers/MyCreations/AddCreation";
import Orders from "./modules/containers/Orders/Orders.jsx";
import Earnings from "./modules/containers/Earnings/Earnings.jsx";
import ViewCreation from "./modules/containers/ViewCreation/ViewCreation.jsx";
import ViewNews from "./modules/containers/News/ViewNews";
import Conversations from "./modules/containers/Conversations/Conversations.jsx";
import Chat from "./modules/containers/Chat/Chat.jsx";
import Explore from "./modules/containers/Explore/Explore.jsx";
import ShipmentDetails from "./modules/containers/Shipments/ShipmentDetails.jsx";
import Library from "./modules/containers/Library/Library";
import SavedNews from "./modules/containers/Library/SavedNews";
import SavedCreations from "./modules/containers/Library/SavedCreations";
import UserProfile from "./modules/containers/UserProfile/UserProfile.jsx";
import PublicProfileGate from "./modules/containers/UserProfile/PublicProfileGate.jsx";
import ContributePage from "./modules/containers/ContributePage/ContributePage.jsx";
import EditNetworks from "./modules/containers/EditNetworks/EditNetworks.jsx";
import Shipments from "./modules/containers/Shipments/Shipments.jsx";
import ShippingAddresses from "./modules/containers/ShippingAddresses/ShippingAddresses.jsx";
import ShippingMethods from "./modules/containers/ShippingMethods/ShippingMethods.jsx";
import PaymentHistory from "./modules/containers/PaymentHistory/PaymentHistory.jsx";
import PaymentHistoryList from "./modules/containers/PaymentHistory/PaymentHistoryList.jsx";
import Withdrawals from "./modules/containers/Withdrawals/Withdrawals.jsx";
import TransactionSummaryList from "./modules/containers/Withdrawals/TransactionSummaryList.jsx";
import CreatorAnalytics from "./modules/containers/CreatorAnalytics/CreatorAnalytics.jsx";
import CreationAnalyticsDetail from "./modules/containers/CreatorAnalytics/CreationAnalyticsDetail.jsx";
import NewsAnalyticsDetail from "./modules/containers/CreatorAnalytics/NewsAnalyticsDetail.jsx";
import CategoryCollection from "./modules/containers/CategoryCollection/CategoryCollection.jsx";
import NotificationList from "./modules/containers/NotificationList/NotificationList.jsx";
import { NavigationProvider } from "./modules/navigation/NavigationContext.jsx";
import SignUpByCommLink from "./modules/containers/Auth/SignUpByCommLink.jsx";
import SignUp from "./modules/containers/Auth/SignUp.jsx";
// import PrivacySettings from "./modules/components/Settings/PrivacySettings.jsx";
import EarningHistoryList from "./modules/containers/Earnings/EarningHistoryList.jsx";
import CompleteProfileV2 from "./modules/containers/Auth/CompleteProfileV2.jsx";
import AddSocialLinks from "./modules/containers/Auth/AddSocialLinks.jsx";
import Search from "./modules/containers/Search/Search.jsx";
import OrderDetails from "./modules/containers/Orders/OrderDetails.jsx";
import RecentlyPurchased from "./modules/containers/Library/RecentlyPurchased.jsx";
import RecentlyAdded from "./modules/containers/Library/RecentlyAdded.jsx";
import ModifyCreation from "./modules/components/ModifyCreation/ModifyCreation.jsx";
import ContributionList from "./modules/containers/PaymentHistory/ContributionList.jsx";
import OnBoarding from "./modules/containers/OnBoarding/OnBoarding.jsx";
import ConsentManager from "./components/ConsentManager/ConsentManager.jsx";
import ConsentErrorBoundary from "./components/ConsentManager/ConsentErrorBoundary.jsx";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary.jsx";
import useAnalytics from "./hooks/useAnalytics.js";
import { useSentryUser } from "./hooks/useSentryUser.js";
import SoftwallLayout from "./modules/containers/SoftWall/SoftWallLayout.jsx";
import { SoftwallProvider } from "./modules/containers/SoftWall/SoftWall";
import TermsConditions from "./modules/containers/Legal/TermsConditions.jsx";
import LegalNotice from "./modules/containers/Legal/LegalNotice.jsx";
import CookiePolicy from "./modules/containers/Legal/CookiePolicy.jsx";
import PrivacyPolicy from "./modules/containers/Legal/PrivacyPolicy.jsx";


const SignUpToSoftwallRedirect = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  return <Navigate to={`/explore${query ? `?${query}` : ""}`} replace />;
};


const ProtectedRoute = () => {
  const user = useSelector((state) => state.auth?.user || null);
  const session = useSelector((state) => state.auth?.session)
  const loading_auth = useSelector(state => state.auth.loading_auth)

  // const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const fetchUserProfile = useSessionProfile();

  useEffect(() => {
    const initializeSession = async () => {
      setLoading(true);

      try {
        const { data } = await supabase.auth.getSession();
        if (data?.session) {
          // setSession(data.session);
          dispatch(setSessionUser(data.session));
          fetchUserProfile(data.session?.user?.id);
        }
      } catch (error) {
        console.error("Error fetching session:", error);
      } finally {
        setLoading(false);
      }
    };

    initializeSession();

    const { data: listener } = supabase.auth.onAuthStateChange(async (event, newSession) => {
      if (event !== "INITIAL_SESSION" && newSession?.user?.id) {
        fetchUserProfile(newSession.user.id);
      }

      if (!newSession) {
        setTimeout(() => {
          dispatch(setSessionUser(newSession));
        }, 3000)
      } else {
        // setSessionUser(newSession)
        dispatch(setSessionUser(newSession));
      }

    });

    return () => {
      listener?.subscription?.unsubscribe();
    };
  }, [dispatch, fetchUserProfile]);
  // if (loading) return <Loading />;
  if (!loading && !session && !loading_auth) return <Navigate to="/login" replace />;

  return (
    <SoftwallProvider>
      <Layout />
    </SoftwallProvider>
  )
};
const ProtectedAdminRoute = () => {
  const user = useSelector((state) => state.auth?.user || null);
  const session = useSelector((state) => state.auth?.session)
  const loading_auth = useSelector(state => state.auth.loading_auth)

  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const fetchUserProfile = useSessionProfile();

  useEffect(() => {
    const initializeSession = async () => {
      setLoading(true);

      try {
        const { data } = await supabase.auth.getSession();
        if (data?.session) {
          dispatch(setSessionUser(data.session));
          fetchUserProfile(data.session?.user?.id);
        }
      } catch (error) {
        console.error("Error fetching session:", error);
      } finally {
        setLoading(false);
      }
    };

    initializeSession();

    const { data: listener } = supabase.auth.onAuthStateChange(async (event, newSession) => {
      if (event !== "INITIAL_SESSION" && newSession?.user?.id) {
        fetchUserProfile(newSession.user.id);
      }

      if (!newSession) {
        setTimeout(() => {
          dispatch(setSessionUser(newSession));
        }, 3000)
      } else {
        dispatch(setSessionUser(newSession));
      }
    });

    return () => {
      listener?.subscription?.unsubscribe();
    };
  }, [dispatch, fetchUserProfile]);

  if (loading || loading_auth) return <SessionBootstrapSkeleton />;
  if (!loading && !session && !loading_auth) return <Navigate to="/login" replace />;
  if (!user) return <SessionBootstrapSkeleton />;
  if (user?.role !== 'admin') return <ErrorPage title="Not Authorized" />;

  return <LayoutAdmin />;
};

// Redirect component for old creation-detail URLs
const CreationDetailRedirect = () => {
  const [searchParams] = useSearchParams();
  const creation_id = searchParams.get("creation_id");
  
  if (creation_id) {
    return <Navigate to={`/creations/${creation_id}`} replace />;
  }
  
  return <Navigate to="/explore" replace />;
};

// Redirect component for old user-profile URLs
const UserProfileRedirect = () => {
  const [searchParams] = useSearchParams();
  const user_id = searchParams.get("user_id");
  
  if (user_id) {
    return <Navigate to={`/profiles/${user_id}`} replace />;
  }
  
  return <Navigate to="/explore" replace />;
};

/** Legacy /@handle → /handle (see HYK-912). */
function LegacyAtHandleToPathRedirect() {
  const { username } = useParams();
  return <Navigate to={`/${username}`} replace />;
}

// If Supabase redirects to "/" with a code param, forward it to the dedicated callback route.
const RootGoogleCodeRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  if (code) {
    return <Navigate to={`/auth/google/callback${location.search || ""}`} replace />;
  }
  return <Navigate to="/explore" replace />;
};

const RoutesWrapper = () => {

  const { stopScrolling } = useSelector((state) => state.navigation);

  useAnalytics(); // Track pageviews on route changes
  useSentryUser(); // Track user context in Sentry

  useEffect(() => {
    if (stopScrolling) {
      const body = document.body;
      body.style.overflow = 'hidden';
    } else {
      const body = document.body;
      body.style.overflow = 'unset';
    }

  }, [stopScrolling]);

  // useEffect(() => {
  //   function blurInputs() {
  //     const inputs = document.querySelectorAll('input')
  //     inputs.forEach(input => {
  //       input.blur();
  //     });
  //   }

  //   document.addEventListener('touchmove', blurInputs)

  // }, [])


  // Global keyboard detection hook - automatically applies to root element
  // useKeyboardDetection();



  return (

    <Routes>
      {/* Auth routes without bottom navigation */}
      <Route path="/signup" element={<SignUpToSoftwallRedirect />} />
      <Route path="/complete-registration" element={<SignUp />} />
      <Route path="/invite" element={<SignUpByCommLink />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
      <Route path="/send-invite" element={<SendInvite />} />
      <Route path="/send-recover" element={<SendRecover />} />
      <Route path="/recover-password" element={<RecoverPwd />} />

      <Route
        element={<SoftwallLayout />}
      >
        <Route path="/news" element={<News />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/creations/:creation_id" element={<ViewCreation />} />
        {/* Redirect old creation-detail URLs to new RESTful format */}
        <Route path="/creation-detail" element={<CreationDetailRedirect />} />
        <Route path="/news/:news_id" element={<ViewNews />} />
        <Route path="/profiles/:profile_id" element={<UserProfile />} />
        {/* Search is open to logged-out visitors (creations + people) */}
        <Route path="/search/:type?" element={<Search />} />
        {/* Redirect old user-profile URLs to new RESTful format */}
        <Route path="/user-profile" element={<UserProfileRedirect />} />
        <Route path="/contribute/:username" element={<ContributePage />} />
        {/* Legacy /@handle → /handle; must be before /:username */}
        <Route path="/@:username" element={<LegacyAtHandleToPathRedirect />} />
        {/* Public profile: /username (last — static siblings like /news win first) */}
        <Route path="/:username" element={<PublicProfileGate />} />



      </Route>
      {/* Protected routes with bottom navigation */}
      <Route path="/" element={<ProtectedRoute />}>
        <Route index element={<RootGoogleCodeRedirect />} />
        <Route path="/on-boarding" element={<OnBoarding />} />
        <Route path="/profile" element={<CreatorProfile />} />
        <Route path="/my-profile" element={<Profile />} />
        <Route path="/add-social-links" element={<AddSocialLinks />} />
        <Route path="/complete-profile" element={<CompleteProfileV2 />} />
        <Route path="/edit-profile" element={<EditProfileSetting />} />
        <Route path="/invite-community" element={<InviteCommunity />} />
        <Route path="/invite-contacts" element={<InviteContacts />} />
        <Route path="/change-password" element={<ChangePwd />} />

        {/* <Route path="/privacy-settings" element={<PrivacySettings />} /> */}
        <Route path="/notifications" element={<NotificationList />} />
        {/* <Route path="/my-creations" element={<MyCreations />} /> */}

        <Route path="/news/add" element={<WriteNews />} />
        <Route path="/news/:news_id/edit" element={<EditNews />} />
        <Route path="/creations/add" element={<AddCreation />} />
        <Route path="/creations/:creation_id/edit" element={<ModifyCreation />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:order_id" element={<OrderDetails />} />
        <Route path="/shipments" element={<Shipments />} />
        <Route path="/shipments/:order_id" element={<ShipmentDetails />} />
        <Route path="/shipping-addresses" element={<ShippingAddresses />} />
        <Route path="/shipping-methods" element={<ShippingMethods />} />
        <Route path="/earnings" element={<Earnings />} />
        <Route path="/earnings/transactions" element={<EarningHistoryList />} />
        <Route path="/creator-analytics/creations/:creationId" element={<CreationAnalyticsDetail />} />
        <Route path="/creator-analytics/news/:newsId" element={<NewsAnalyticsDetail />} />
        <Route path="/creator-analytics" element={<CreatorAnalytics />} />

        <Route path="/conversations" element={<Conversations />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/library" element={<Library />} />
        <Route path="/library/saved-news" element={<SavedNews />} />
        <Route path="/library/saved-creations" element={<SavedCreations />} />
        <Route path="/library/recently-purchased" element={<RecentlyPurchased />} />
        <Route path="/library/recently-added" element={<RecentlyAdded />} />
        <Route path="/collection/:collection_category" element={<CategoryCollection />} />
        <Route path="/edit-networks" element={<EditNetworks />} />
        <Route path="/payments-history" element={<PaymentHistory />} />
        <Route path="/payments-history/transactions" element={<PaymentHistoryList />} />
        <Route path="/payments-history/contributions" element={<ContributionList />} />
        <Route path="/withdrawals" element={<Withdrawals />} />
        <Route path="/withdrawals/transactions" element={<TransactionSummaryList />} />
      </Route>

      {/* Admin routes */}
      <Route path="/admin" element={<ProtectedAdminRoute />}>
        <Route index element={<SimplifiedDashboard />} />
        <Route path="/admin/dashboards" element={<DashboardsLayout />}>
          <Route path="/admin/dashboards/overview" element={<Overview />} />
          <Route path="/admin/dashboards/revenue" element={<Revenue />} />
          <Route path="/admin/dashboards/creators" element={<Creators />} />
          <Route path="/admin/dashboards/users" element={<Engagement />} />
        </Route>
        <Route path="/admin/news" element={<NewsDashboard />} />
        <Route path="/admin/news/:news_id" element={<AdminNewsDetail />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/users/:user_id" element={<AdminUserProfile />} />
        <Route path="/admin/invite" element={<InviteUsers />} />
        <Route path="/admin/creation" element={<Creations />} />
        <Route path="/admin/creation/:creation_id" element={<AdminCreationDetail />} />
        <Route path="/admin/new" element={<Content />} />
        <Route path="/admin/content" element={<Navigate to="/admin/creation" replace />} />
        <Route path="/admin/paiements" element={<Paiements />} />
      </Route>

      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/legal-notice" element={<LegalNotice />} />
      <Route path="/cookies" element={<CookiePolicy />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="*" element={<NotFound label="Page Not Found" />} />
    </Routes>

  );
}

function App() {
  const dispatch = useDispatch();

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <NavigationProvider
          onNavigate={(prev, curr) => {
            if (curr.pathname === '/explore') {
              dispatch({ type: 'CLEAR_HEAT_MAP', payload: false })
            } else {
              dispatch({ type: 'CLEAR_HEAT_MAP', payload: true })
            }
          }}
        >
          <ConsentErrorBoundary>
            <ConsentManager />
          </ConsentErrorBoundary>
          <RoutesWrapper />
        </NavigationProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
